import { ReadActionKey } from 'owa-outlook-service-options';

export const menuKeysInOrder: ReadActionKey[] = [
    'Reply',
    'ReplyAll',
    'Forward',
    '-',
    'Delete',
    'Archive',
    'Move',
    'Copy',
    'Categorize',
    'MarkAsRead',
    'MarkAsUnread',
    'Flag',
    'Unflag',
    'Pin',
    'Unpin',
    'Snooze',
    'Ignore',
    'MessageSafety',
    '-',
    'View',
    'AdvancedActions',
];
